module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ReplaceApplyView.js"));
	}, "ReplaceApplyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ReplaceApplyView!./src/pages/Promote/BusinessHall/ReplaceApply/ReplaceApplyView.js
// module id = 1152
// module chunks = 431